import RequestSummaryItemResourceModel from '../../generated/types/model/resource/RequestSummaryItemResourceModel';

export default class RequestSummaryItemResourceViewModel extends RequestSummaryItemResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
